/**
 * Magnetic declination for Switzerland (constant over the country).
 * NOAA WMM2025 for 47.0 N / 8.4 E: 3.6 deg east at 2026.72, secular drift
 * +0.12 deg/year. East is positive: true heading = magnetic heading + declination.
 */

export const DECLINATION_REF_DEG = 3.6;
export const DECLINATION_REF_YEAR = 2026.72;
export const DECLINATION_DRIFT_DEG_PER_YEAR = 0.12;

/** Decimal year (UTC), e.g. 2026-07-02 -> ~2026.5. */
export function decimalYear(date: Date): number {
  const y = date.getUTCFullYear();
  const start = Date.UTC(y, 0, 1);
  const end = Date.UTC(y + 1, 0, 1);
  return y + (date.getTime() - start) / (end - start);
}

/** Declination in degrees (east positive) for the given date. */
export function declinationDeg(date: Date = new Date()): number {
  return DECLINATION_REF_DEG + DECLINATION_DRIFT_DEG_PER_YEAR * (decimalYear(date) - DECLINATION_REF_YEAR);
}
